export default "__VITE_ASSET__04756d13__"